



























































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import LendingAccount from "@/models/Accounts/LendingAccounts/LendingAccount";
import Details from '@/components/Accounts/LendingAccounts/Details/Details.vue';
import LedgerSubTabs from '@/components/Accounts/LendingAccounts/Ledgers/LedgerSubTabs.vue';
import Cards from '@/components/Accounts/Shared/Cards/Cards.vue';
import RepaymentPlans from '@/components/Accounts/LendingAccounts/RepaymentPlans/RepaymentPlans.vue';
import Payees from '@/components/Accounts/Shared/Payees/Payees.vue';
import Fees from '@/components/Accounts/Shared/Fees/Fees.vue';
import FeesUnavailableOnAccount from '@/components/Accounts/Shared/Fees/FeesUnavailableOnAccount.vue';
import HistorySubTabs from '@/components/Accounts/Shared/History/HistorySubTabs.vue';
import History from '@/components/Shared/History.vue';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'LendingRevolvingCreditTabs', components: { Details, LedgerSubTabs, RepaymentPlans, Cards, Payees, Fees, FeesUnavailableOnAccount, HistorySubTabs, History } })
export default class extends SaascadaVue {

    tabIndex = 0;

    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;

    @Prop({required: true})
    account: LendingAccount;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    get allowFees(){
        // Allow fees if at least one of the template options is available
        let templatedFeesAvailable = true;
        if (PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.ProductFees)) {
            templatedFeesAvailable = true;
        }
        let manualFeesAvailable = false;
        if (PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.AdHocFees)) {
            manualFeesAvailable = true;
        }
        return templatedFeesAvailable || manualFeesAvailable;
    }

    get defaultWalletCurrency() {
        return this.account.defaultCurrency;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
